import { makeObservable, observable, runInAction, reaction, toJS } from 'mobx';
import axios from "../utils/axios";
import generateUid from "../utils/generateUid";

class multiFileStore {
  data={};
  options={};
  dragging={};
  field_settings={};
  selector_uid="";
  replace_file={
    progress:{ active:false }
  };
  cur_progress={
    active: false,
    percent: 0,
    index: 0,
    cur_ob: null,
    total_size: 0,
    total_files: 0,
    uploaded_size: 0
  };
  constructor(dataset) {
    makeObservable(this, {
      data: observable,
      options: observable,
      cur_progress: observable,
      replace_file: observable,
      selector_uid: observable,
      dragging: observable,
      field_settings: observable,
    });

    this.selector_uid=generateUid();
    console.log("generate_uid", this.selector_uid);

    window.EvaWithSelectedOnReady.push(()=>{
      // window.EvaWithSelected.registerLayout(this.selector_uid, {left:["delete_btn"], right:["unselect_btn"]});
      window.EvaWithSelected.registerLayout(this.selector_uid, {left:[
          {
            preset: "delete_btn",
            condition: (items, by_id) => {
              for (let i in items) {
                if (!items[i].delete) {
                  return true;
                }
              }
              return false;
            }
          },
          {
            action: "restore",
            type: "btn8",
            title: "Отменить удаление",
            mdi: "delete-restore",
            condition: (items, by_id) => {
              for (let i in items) {
                if (items[i].delete) {
                  return true;
                }
              }
              return false;
            }
          }
        ], right:["unselect_btn"]});
      window.EvaWithSelected.addListener(this.selector_uid, (action, data)=>{
        if(action === "system:unselect_item") {

        }
        if(action === "system:select_item") {

        }
        if(action === "restore") {
          this.getSelected().forEach((item)=>{
            const found=this.findFileById(item.sys_uid);
            delete found.field.delete;
          });
          window.EvaWithSelected.clearSelection();
        }
        if(action === "delete") {
          this.getSelected().forEach((item)=>{
            const found=this.findFileById(item.sys_uid);
            found.field.delete=1;
          });
          this.setMarkFileWas();
          window.EvaWithSelected.clearSelection();
        }
        console.log("FIRE ACTION", action, data, toJS(window.EvaWithSelected.items));
      })
    });

    if(dataset.data) {
      this.data = dataset.data;
    }

    this.options.inputName=dataset.inputName
    if(dataset.placeholder) {
      this.options.placeholder = dataset.placeholder
    }

    if(dataset.uploadOptions) {
      console.log("UPLOAD OPTIONS", dataset.uploadOptions);
      console.log("UPLOAD OPTIONS", JSON.parse(dataset.uploadOptions));
      this.options.uploadOptions=JSON.parse(dataset.uploadOptions);
    } else {
      this.options.uploadOptions={};
    }

    if(dataset.fieldSettings) {
      this.field_settings=JSON.parse(dataset.fieldSettings);
    }
    if(dataset.data) {
      const json=JSON.parse(dataset.data);
      if(json) {
        this.data=json;
      }
    }
  }
  setMarkFileWas() {
    const items=document.querySelectorAll('.editFormMain');
    if(items.length) {
      items[0].eva_gallery_changed = true;
    }
  }
  resetCurProgress() {
    this.cur_progress = {
      percent: 0,
      index: 0,
      cur_ob: null,
      total_size: 0,
      uploaded_size: 0,
      total_files: 0,
      uploaded_files: 0
    };
  }
  clickOnItem(e, item) {
    /*if(e.shiftKey) {
      if (this.getSelected().length) {
        this.getSelected().last
      }
    }*/
    console.log(`ctrl=${e.ctrlKey?"true":"false"}`,`shift=${e.shiftKey?"true":"false"}`,`meta=${e.metaKey?"true":"false"}`)

    if(e.shiftKey) {
      if (this.getSelected().length) {
        const last=this.getSelected()[this.getSelected().length-1];
        const lastFind=this.findFileById(last.sys_uid);
        const curFind=this.findFileById(item.sys_uid);

        const lastSort=last.sort;
        const min=Math.min(lastFind.index, curFind.index);
        const max=Math.max(lastFind.index, curFind.index);

        runInAction(()=> {
          for (let i = min; i <= max; i++) {
            this.selectItem(this.data[i]);
          }
        });
      } else {
        this.toggleItem(item);
      }
    }

    if(e.ctrlKey || e.metaKey) {
      this.toggleItem(item);
    }

    if(!e.ctrlKey && !e.metaKey && !e.shiftKey) {
      this.clearSelection();
      this.toggleItem(item);
    }
  }
  findFileById(id){
    for (let i in this.data) {
      if (this.data[i].sys_uid === id) {
        return {index: parseInt(i), field: this.data[i]};
      }
    }
    return null;
  }
  getSelected() {
    return window.EvaWithSelected.items;
  }
  clearSelection() {
    return window.EvaWithSelected.clearSelection();
  }
  toggleItem(ob) {
    return window.EvaWithSelected.toggleItem(this.selector_uid, ob);
  }
  unselectItem(ob) {
    return window.EvaWithSelected.unselectItem(this.selector_uid, ob);
  }
  selectItem(ob) {
    return window.EvaWithSelected.selectItem(this.selector_uid, ob);
  }
  isSelected(id) {
    return window.EvaWithSelected.isSelected(this.selector_uid, id);
  }
  getSelectionNumber(id) {
    return window.EvaWithSelected.by_id[id];
  }
  prepareSort() {
    for (let i in this.data) {
      const need = parseInt(i) + 1;
      if (need !== this.data[i].sort) {
        this.data[i].sort = need;
      }
    }
  }
  getCur(cur) {
    if(this.field_settings && this.field_settings.title_field) {
      if(typeof cur[this.field_settings.title_field] === "undefined") {
        cur[this.field_settings.title_field]={};
      }
      return cur[this.field_settings.title_field];
    } else {
      return cur;
    }
  }
  uploadNext(recursion=false) {
    if(!recursion) {
      this.setMarkFileWas();
      runInAction(()=>{
        this.resetCurProgress();
        this.cur_progress.active=true;
        this.cur_progress.uploaded_files=0;
        for (let i in this.data) {
          const cur = this.data[i];
          if (cur.uploading_file) {
            this.cur_progress.total_size+=cur.uploading_file.size;
          }
          if (cur.uploading_file || cur.uploading_url) {
            this.cur_progress.total_files += 1;
          }
          cur.progress=0;
        }
      });
      console.log("this.cur_progress", toJS(this.cur_progress));
    }
    for (let i in this.data) {
      const cur = this.data[i];
      if (cur.uploading_file || cur.uploading_url) {
        const startTotal=toJS(this.cur_progress.uploaded_size);
        var formData = new FormData();
        if(cur.uploading_file) {
          formData.append("file", cur.uploading_file);
        }
        if(cur.uploading_url) {
          formData.append("url", cur.uploading_url);
        }
        formData.append("upload_options", JSON.stringify(toJS(this.options.uploadOptions)));

        axios.post('/sysapi/upload_tmp_file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            if(cur.uploading_file) {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              runInAction(() => {
                cur.progress = percentCompleted;
                this.cur_progress.uploaded_size = startTotal + progressEvent.loaded;
                this.cur_progress.percent = Math.round(this.cur_progress.uploaded_size * 100 / this.cur_progress.total_size);
                this.cur_progress.index = parseInt(i);
                this.cur_progress.cur_ob = cur;
                console.log('this.cur_progress', toJS(this.cur_progress));
              });
            } else {
              runInAction(() => {
                cur.progress=100;
                this.cur_progress.index = parseInt(i);
                this.cur_progress.cur_ob = cur;
                this.cur_progress.percent = 100;
                this.cur_progress.inf_uploading = true;
              });
            }
          }
        }).then((data) => {
          this.cur_progress.uploaded_files++;
          runInAction(()=> {
            if (data.data.answer) {
              if (data.data.answer.success) {
                cur.success = true;
                this.getCur(cur).tmp_file = data.data.answer;
              }
            }
            if(!cur.success) {
              cur.fail=true;
            }
            cur.uploading = false;
            delete cur.uploading_file;
            delete cur.uploading_url;
          });
          this.uploadNext(true);
        }).catch((data) => {
          runInAction(()=> {
            cur.uploading = false;
            delete cur.uploading_file;
            delete cur.uploading_url;
            cur.fail=true;
          });
          this.uploadNext(true);
        });
        return true;
      }
    }
    runInAction(()=> {
      this.resetCurProgress();
      this.cur_progress.active=false;
      setTimeout(()=>{
        const deleteIds=[];
        for(let i in this.data) {
          if(this.data[i].fail) {
            deleteIds.push(this.data[i].sys_uid);
          }
        }
        if(deleteIds.length > 0) {
          for(let i in deleteIds) {
            const found=this.findFileById(deleteIds[i]);
            if(found) {
              this.data.splice(found.index, 1);
            }

          }
        }
      },4000);
    });
    return true;
  }
  replaceCurFile(fileOrUrl) {
    this.setMarkFileWas();
    const isFile = typeof fileOrUrl !== "string";

    var formData = new FormData();
    if (isFile) {
      formData.append("file", fileOrUrl);
    } else {
      formData.append("url", fileOrUrl);
    }
    formData.append("upload_options", JSON.stringify(toJS(this.options.uploadOptions)));

    axios.post('/sysapi/upload_tmp_file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        runInAction(() => {
          this.replace_file.progress = {
            active: true,
            percent: 99,
            total: 0,
            uploaded: 0
          }
        });
      }
    }).then((data) => {
      console.log("CUR_FILE THEN", data);
      runInAction(() => {
        this.replace_file.progress = {
          active: false
        };
        if (data.data.answer) {
          if (data.data.answer.success) {
            const curFileId = this.getSelected()[0].sys_uid;
            const curFile = this.findFileById(curFileId).field;
            const newFile = data.data.answer;

            if (this.getCur(curFile).tmp_file) {
              axios.post("/sysapi/delete_tmp_file", {token: this.getCur(this.getSelected()[0]).tmp_file.token}).then((data) => {
                if (data.data.answer) {
                  this.getCur(curFile).tmp_file = newFile;
                  curFile.success = true;
                }
              });
            } else {
              this.getCur(curFile).tmp_file = newFile;
            }
          } else {
            console.log("CUR_FILE NOPE");
          }
        }
      });
    }).catch((data) => {
      this.replace_file.progress = {
        active: false,
      };
    });

  }
}

export default multiFileStore;